<template>
	<div>
  <div class="page-title">
    <h3>Счет</h3>

    <button class="btn waves-effect waves-light btn-small" @click="refresh">
      <i class="material-icons">refresh</i>
    </button>
  </div>

  <Loader v-if="loading" />

  
    
   

   <div v-else class="row">

  <HomeBill
  :rates="currency.rates"
  

   />

  <HomeCurency
    :rates="currency.rates"
    :date="currency.date"
   />

  </div>     
</div>
</template>

<script>
  //перед парам внутр компонента
  import HomeBill from '@/components/HomeBill' 
  import HomeCurency from '@/components/HomeCurency'

  export default {
    name: 'home',
        metaInfo() {
      return { 
       title: this.$title('Menu_Bill')
        }
      
    },
    //показываем в том случае если модель лоадинг тру
    //в поле дата будут храниться определеныне модели
    // лоадинг и каренси, данные котор приду с серв и будут отв за валюты
    data: ()=>({
      loading: true,
      currency: null
    }),
    //чтобы из использовать компон надо зарегистр
    //они будут видны только на стр хоме и это подходит
     async mounted() {
    this.currency = await this.$store.dispatch('fetchCurrency')
    console.log(this.currency)
    this.loading = false
  },
    methods:{
      //перезагрузка страницы
      async refresh(){
        this.loading = true
        this.currency = await this.$store.dispatch('fetchCurrency')
        this.loading = false
      }
    },

    components: {
      HomeBill, HomeCurency
    }
  }
</script>